import {StaffPerformanceColumnsConfig} from 'constants'
import StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy from './StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy'
import StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy from './StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy'
import StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy from './StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy'
import StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy from './StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy'
import StaffPerformanceHTMLPreviewHeaderSection from './StaffPerformanceHTMLPreviewHeaderSection'
import StaffPerformanceHTMLPreviewGroupingSection from './StaffPerformanceHTMLPreviewGroupingSection'
import StaffPerformanceHTMLPreviewLeaveSection from './StaffPerformanceHTMLPreviewLeaveSection'
import UserGroupMessageProvider from '../../UserGroupMessageProvider'
import TimeZoneGroupMessageProvider from '../../TimeZoneGroupMessageProvider'

export default function StaffPerformanceHTMLPreviewGenerator() {}

StaffPerformanceHTMLPreviewGenerator.prototype.init = function()
{
    return this;
};
StaffPerformanceHTMLPreviewGenerator.prototype.generatePreviewTable = function( reportParameters )
{
    let columnsStrategy
    const columnConfig = reportParameters.columnsConfig
    const includeOtherUsersColumn = reportParameters.includeOtherUsersColumn

    switch (columnConfig) {
        case StaffPerformanceColumnsConfig.USERS_ONLY:
            columnsStrategy = new StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy().init(
                reportParameters.timeFormat,
                includeOtherUsersColumn,
                reportParameters.needSwitchToMe,
            )
            break
        case StaffPerformanceColumnsConfig.GROUPS_ONLY:
        case StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY:
            columnsStrategy = new StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy().init(
                reportParameters.timeFormat,
                this.getGroupMessageProvider(columnConfig),
                includeOtherUsersColumn,
            )
            break
        case StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS:
        case StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS:
            columnsStrategy = new StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy().init(
                reportParameters.timeFormat,
                this.getGroupMessageProvider(columnConfig),
                includeOtherUsersColumn,
            )
            break
        case StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS:
        case StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS:
            columnsStrategy = new StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy().init(
                reportParameters.timeFormat,
                this.getGroupMessageProvider(columnConfig),
            includeOtherUsersColumn,
            )
    }

    let header = new StaffPerformanceHTMLPreviewHeaderSection().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        columnsStrategy,
    )


    let dataGroupingSection = new StaffPerformanceHTMLPreviewGroupingSection().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        !reportParameters.showLeaveTime,
        columnsStrategy,
    )

    let table = document.createElement( "table" )
    table.className = "reportHtmlPreviewTable staffPerformance";
    let tBody = document.createElement( "tbody" )
    table.appendChild( tBody );
    header.addRows( tBody );

    if( reportParameters.showLeaveTime )
        new StaffPerformanceHTMLPreviewLeaveSection().init( columnsStrategy ).addRows( tBody );

    dataGroupingSection.addRows( tBody );

    return table;
};

StaffPerformanceHTMLPreviewGenerator.prototype.getGroupMessageProvider = function(columnConfig){
         switch (columnConfig){
             case StaffPerformanceColumnsConfig.GROUPS_ONLY:
             case StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS:
             case StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS:
                 return new UserGroupMessageProvider();
             case StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS:
             case StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY:
             case StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS:
                 return new TimeZoneGroupMessageProvider();
         }
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewGenerator.js